"use client";

import { AnimatePresence, motion } from "framer-motion";
import React, { FC, ReactElement, useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

import { ModalContentType } from "@/components/ui/Modal/ModalContent";

interface Props {
  children: ReactElement<ModalContentType>;
  open: boolean;
  className?: string;
  onClose: () => void;
  topPositioned?: boolean;
  avoidOverflowHidden?: boolean;
}
const Modal: FC<Props> = ({ children, open = false, className, onClose, topPositioned, avoidOverflowHidden }) => {
  const overlay = useRef<HTMLDivElement>(null);
  const [hasDocument, setHasDocument] = useState<boolean>(false);
  // BUG 88195
  const [mouseDownTargetIsOverlay, setMouseDownTargetIsOverlay] = useState<boolean>(false);

  useEffect(() => {
    if (typeof document !== "undefined") {
      setHasDocument(true);
    }
  }, []);

  const keyboardHandler = useCallback(
    (event: KeyboardEvent) => {
      if (event.key?.toLowerCase() === "escape") {
        onClose();
        document.body.classList.remove("overflow-hidden");
      }
    },
    [onClose],
  );

  useEffect(() => {
    if (!open) return;
    document.addEventListener("keydown", keyboardHandler);
    return () => {
      document.removeEventListener("keydown", keyboardHandler);
    };
  }, [keyboardHandler, open]);

  useEffect(() => {
    if (document) {
      document.addEventListener("keydown", keyboardHandler);
      return () => {
        document.removeEventListener("keydown", keyboardHandler);
      };
    }
  }, [keyboardHandler]);

  useEffect(() => {
    document.body.classList[open ? "add" : "remove"]("overflow-hidden");
  }, [open]);

  return hasDocument ? (
    createPortal(
      <AnimatePresence>
        {open && (
          <motion.div
            ref={overlay}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={(e: any) => {
              if (e.target == overlay.current && mouseDownTargetIsOverlay) {
                onClose();
              }
              // TODO: CHECK THIS LOGIC

              if (!avoidOverflowHidden) {
                document.body.classList.remove("overflow-hidden");
              }
            }}
            className={`fixed top-0 left-0 w-dvw h-dvh z-50 bg-black/40 flex items-end ${topPositioned ? "md:items-start md:pt-[110px]" : "md:items-center"} justify-center ${className}`}
            onMouseDown={(e: any) => setMouseDownTargetIsOverlay(e.target == overlay.current)}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>,
      document.body,
    )
  ) : (
    <></>
  );
};
export default Modal;
